import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../models/user';

@Component({
  selector: 'ngx-parent-selector',
  templateUrl: './parent-selector.component.html',
  styleUrls: ['./parent-selector.component.scss']
})
export class ParentSelectorComponent implements OnInit {
  @Input()
  public parentEntities: Array<User> = [];

  constructor() { }

  ngOnInit() {
    console.log('this.parentEntities', this.parentEntities);
  }

}
